export default __webpack_public_path__ + "static/media/notification-2.0a6c2557.mp3";